var LogoView = require('../../geo/ui/logo-view');

var LogoOverlay = function (data, opts) {
  var view = new LogoView();

  return view.render();
};

module.exports = LogoOverlay;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/vis/overlays/logo.js
// module id = 1706
// module chunks = 6